import React from 'react';
import PropTypes from 'prop-types';
import useStores from '../../hooks/useStore';
import { observer } from 'mobx-react-lite';

import { TabContent } from './styles';

const tabContentVariant = {
  active: {
    display: 'block',
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
    },
  },
  inactive: {
    display: 'none',
    opacity: 0,
    y: 20,
    transition: {
      duration: 0.5,
    },
  },
};

const cardVariant = {
  active: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
    },
  },
  inactive: {
    opacity: 0,
    y: 10,
    transition: {
      duration: 0.5,
    },
  },
};

const TabContainer = observer(({ children, id }) => {
  const { UIStore } = useStores();

  const { activeTab, setActiveTab } = UIStore;
  return (
    <TabContent
      variants={tabContentVariant}
      animate={activeTab === id ? 'active' : 'inactive'}
      initial="inactive"
    >
      {children}
    </TabContent>
  );
});

TabContainer.propTypes = {
  children: PropTypes.object.isRequired,
};

export default TabContainer;
